// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2x9lQ","inner":"Form_inner__134Gi","range":"Form_range__1PfM3","name":"Form_name__3bDYe","actions":"Form_actions__2vJld"};